module.exports = __webpack_public_path__ + "img/好主人宠物食品123.6262e55a.png";